// extracted by mini-css-extract-plugin
export default {"Paper":"AcademyEducation_Paper__4XZjM","Alert":"AcademyEducation_Alert__1BIpC","Button":"AcademyEducation_Button__OXMeo"};